module.exports = __webpack_public_path__ + "fonts/boxicons.1ec26ee1.woff2";